__turbopack_context__.v({
  "className": "cormorant_garamond_3263a12f-module__VDJ63G__className",
});
